export enum SettingActionTypes {
    API_RESPONSE_SUCCESS = '@@setting/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@setting/API_RESPONSE_ERROR',

    GET_SETTINGS = '@@setting/GET_SETTINGS',
    SET_SETTINGS = '@@setting/SET_SETTINGS',
}
